export const definitions = {
	'Net Sales': {
		definition:
			'Revenue as recorded financially (may also see net sales labeled as revenue in reporting). For all sales except marketplace (MP) and services, net sales = GMV. However, for MP and services sales, net sales is commission.',
		aggregation: {
			label: 'Formula',
			preList:
				'Calculated at an item level and aggregated as a sum across the following levels:',
			list: [
				'Item hierarchy: Category, Subcategory, Brand',
				'Location hierarchy: Region, Subdivision, Store',
				'Selected Time range',
			],
			postList:
				'YoY % calculation = (TY sales number - LY sales number) / LY sales number * 100',
		},
	},
	Units: {
		definition:
			'Total number of units sold to customers for transactions online and in store.',
		aggregation: {
			label: 'Formula',
			preList:
				'Calculated at an item level and aggregated as a sum across the following levels:',
			list: [
				'Item hierarchy: Category, Subcategory, Brand',
				'Location hierarchy: Region, Subdivision, Store',
				'Selected Time range',
			],
			postList:
				'YoY % calculation = (TY Units number - LY Units number) / LY Units number * 100',
		},
	},
	AUR: {
		definition:
			'Average Unit Revenue (AUR) reflects the average price (excluding savings, discounts, or shopping revenues) of the sold items in your category or sub-category.',
		aggregation: {
			label: 'Formula',
			preList: 'Average Unit Retail (AUR) is GMV divided by Units.',
			list: null,
			postList: null,
		},
	},
	'Net Sales YoY % Change': {
		definition:
			'Year over year change percentage for Net Sales = (Net Sales this year - Net Sales last year) / Net Sales last year',
		aggregation: {},
	},
	'Units YoY % Change': {
		definition:
			'Year over year change percentage for Units = (Units this year - Units last year) / Units last year',
		aggregation: {},
	},
	'AUR YoY % Change': {
		definition:
			'Year over year change percentage for AUR = AUR this year - AUR last year) / AUR last year',
		aggregation: {},
	},
	'Store On Hand Quantity': {
		definition: 'The quantity of an item which is on-hand at this store.',
		aggregation: {
			label: 'Formula',
			preList: 'Sum of On hand Quantity divided by no of days.',
			list: null,
			postList: null,
		},
	},
	'Store On Order Quantity': {
		definition:
			'The number of units on a purchase order allocated specifically to the store.',
		aggregation: {
			label: 'Formula',
			preList: 'Sum (On Order quantity)/ Number of days',
			list: null,
			postList: null,
		},
	},
	'Store In Transit Quantity': {
		definition:
			'The number of units invoiced by DC to the store but not yet received and finalized.',
		aggregation: {},
	},
	'Store In Warehouse Quantity': {
		definition:
			'The number of units received by the DC which are allocated specifically to a store but not yet shipped (invoiced).',
		aggregation: {
			label: 'Formula',
			preList:
				'In-warehouse retail = In-warehouse quantity(Item) * Retail Amount(Item)',
		},
	},
	'Total Store Inventory': {
		definition:
			'Total Store Inventory is the sum of On Hand, On Order, In Transit and In Warehouse Quantities.',
		aggregation: {
			label: 'Formula',
			preList:
				'(Sum Of Total On Hand Inventory and Total On Order Inventory and Total In Transit Inventory and Total In WHSE quantity/ No Of days)',
		},
	},
	'Store On Hand Quantity YoY % Change': {
		definition:
			'Year over year change percentage for Store On Hand Quantity = (Store On Hand Quantity this year - Store On Hand Quantity last year) / Store On Hand Quantity last year',
		aggregation: {},
	},
	'Store On Order Quantity YoY % Change': {
		definition:
			'Year over year change percentage for Store On Order Quantity = (Store On Order Quantity this year - Store On Order Quantity last year) / Store On Order Quantity last year',
		aggregation: {},
	},
	'Store In Transit Quantity YoY % Change': {
		definition:
			'Year over year change percentage for Store In Transit Quantity = (Store In Transit Quantity this year - Store In Transit Quantity last year) / Store In Transit Quantity last year',
		aggregation: {},
	},
	'Store In Warehouse Quantity YoY % Change': {
		definition:
			'Year over year change percentage for Store In Warehouse Quantity = (Store In Warehouse Quantity this year - Store In Warehouse Quantity last year) / Store In Warehouse Quantity last year',
		aggregation: {},
	},
	'Total Store Inventory YoY % Change': {
		definition:
			'Year over year change percentage for Total Store Inventory = (Total Store Inventory this year - Total Store Inventory last year) / Total Store Inventory last year',
		aggregation: {},
	},
	'Instock %': {
		definition:
			'It is a measurement on the percentage of the inventory that is getting replenished that becomes in stock inventory',
		aggregation: {},
	},
	'Instock % YoY % Change': {
		definition:
			'Year over year change percentage for Repl Instock = (Repl Instock % this year - Repl Instock % last year) / Repl Instock % last year',
		aggregation: {},
	},
	'Dollar/Store/Week': {
		definition:
			'The average of the total net sales, per distinct valid store, over the number of weeks during the selected Walmart week for the included stores.',
		aggregation: {
			label: 'Formula',
			preList:
				'Total net sales/number of stores/number of weeks • For the Total net sales, it is POS sales, which is pos_sales_this_year in chnl_perf_store_fact_dly • For the number of stores, it is valid store count, in the table ww_chnl_perf_app.chnl_perf_store_sku_dly, do ty_repl_ind = 1, enter the right bus_dt and wm_item_nbr, to get the corresponding store_nbr and only do distinct count valid store. • For the number of weeks or days, that’s based on the selection user made in report builder calendar. Eg if they select last 4 weeks, then it will be 4.',
		},
	},
	'Units/Store/Week': {
		definition:
			'The average of the number of units for the total net sales, per distinct valid store, over the number of weeks during the selected Walmart for the included stores.',
		aggregation: {
			label: 'Formula',
			preList: 'Units of Total net sales/number of stores/number of weeks',
		},
	},
	'Dollar/Store/Week YoY % Change': {
		definition:
			'Year over year change percentage for Dollar/Store/Week = (Dollar/Store/Week this year - Dollar/Store/Week last year) / Dollar/Store/Week last year',
		aggregation: {},
	},
	'Units/Store/Week YoY % Change': {
		definition:
			'Year over year change percentage for Units/Store/Week = (Units/Store/Week this year - Units/Store/Week last year) / Units/Store/Week last year',
		aggregation: {},
	},
	'FTPR Rate': {
		definition:
			'The calculation that identifies the percentage of items that were picked as ordered the first time',
		aggregation: {
			label: 'Formula',
			preList: 'Sum(Quantity of the Items picked up the first time)',
		},
	},
	'Pre Sub Rate': {
		definition:
			'This is an indicator of how often the customer got exactly what they ordered before any substitution.',
		aggregation: {
			label: 'Formula',
			preList:
				'(Pre-Substitute Rate Numerator) / (Pre-Substitute Rate Denominator)',
		},
	},
	'Post Sub Rate': {
		definition:
			'An indicator of how often the customer got an item for their order including substitutions and manager approved overrides.',
		aggregation: {
			label: 'Formula',
			preList:
				'(Post Substitute Rate Numerator) / (Post Substitute Rate Denominator).',
		},
	},
	'Nil Pick Rate': {
		definition:
			'The percentage of items that were not fulfilled for scheduled orders. This is reported in a percent.',
		aggregation: {
			label: 'Formula',
			preList:
				'(Scheduled Nil Pick Rate Numerator) / (Scheduled Nil Pick Rate Denominator).',
		},
	},
	'FTPR Quantity': {},
	'Pre Sub Quantity': {
		definition:
			'Measures the sum of items picked as ordered and manager approved overrides.',
		aggregation: {},
	},
	'Post Sub Quantity': {
		definition:
			'Defines a similar item that is picked when the original ordered item is not available or is not found in a store',
		aggregation: {},
	},
	'Nil Pick Quantity': {
		definition:
			'This is a measure of the of units not picked or substituted by a store. In other words, Quantity Not Picked',
		aggregation: {
			label: 'Formula',
			preList: 'Sum(Quantity of the Items not picked)',
		},
	},
	'Total Order Quantity': {
		definition:
			'The total number of units ordered by the customer and received by the store.',
		aggregation: {
			label: 'Formula',
			preList: 'Sum(Quantity of Items ordered by the customer)',
		},
	},
	'Sub Quantity': {
		definition:
			'Defines a similar item that is picked when the original ordered item is not available or is not found in a store',
		aggregation: {},
	},
};
